import React, { Component } from 'react'
import ReportGeneralTable from '../report/ReportGeneralTable'
import TyreStore from 'stores/TyreStore'
import TyreRepairDoc from './TyreRepairDoc'
import FontAwesome from 'react-fontawesome'
import { Popover, OverlayTrigger} from 'react-bootstrap'
import withSizes from 'react-sizes'

const cHeaderTitles = [
    {title:'วันที่',width:'100px'},
    {title:'หมายเลขใบซ่อมยาง',width:'110px'},
    {title:'ทะเบียนรถ',width:'110px'},
    {title:'ชนิดรถ',width:'100px'},
    {title:'ล้อที่',width:'70px'},
    {title:'หมายเลขใบแจ้งหนี้',width:'110px'},
    {title:'จำนวนเงิน',width:'100px'}
]
class ReportTyreRepairPage extends Component {
    constructor(props) {
      super(props)
      
      this.state = {
            showTable:true,
            showClose:false,
            loadClose:false
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.showTbReportTyreRepairPage) {
            this.setState({showTable:newProps.showTbReportTyreRepairPage})
            this.showTable()
        }
    }

    loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback) {
        TyreStore.loadReportRepair(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
            callback(result)
        })
    }

    loadDataRange(start,end,searchBy,query,activePage,itemPerPage,callback){
        TyreStore.loadReportRepairRange(start,end,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
            callback(result)
        })
    }
  
    showTable(){
        this.setState({showTable:true,showClose:true,loadClose:true})
        if (this.props.onTableShow!==undefined){
          this.props.onTableShow()
        }
    }
    
    onRowSelect(item){
        this.setState({showTable:false,showClose:false,loadClose:false})
        this.refs.trDoc.loadData(item.tyre_repair_no)
        if (this.props.onDocShow!==undefined) {
            this.props.onDocShow(item.tyre_repair_no)
        }
        this.props.onShowTabs(false)
    }
    
    onDocNew(){
        this.setState({showTable:false})
        this.refs.trDoc.loadNewDoc((item)=>{
            if (this.props.onDocShow!==undefined) {
                this.props.onDocShow(item.tyre_repair_no)
            }
        })
        this.props.onShowTabs(false)
    }
    
    onDocClose(){
        this.showTable() 
        this.props.onShowTabs(true)
    }

    onIconClick() {
        
    }
    
    onRenderColumn(data,col,row){ 
        if (col===1) {
            if (row.tyre_repair_no!=="") {
                let title = "ใบงานซ่อมยาง "+row.tyre_repair_no
                let popoverHoverFocus = (
                    <Popover id="popover-trigger-hover-focus" title={title}>
                        <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
                    </Popover>
                )
    
                return(
                    <span>
                        {row.tyre_repair_no} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,row.tyre_repair_no)} className="text-blue" name='file-text-o'/></OverlayTrigger>
                    </span>
                )
            }
        } else {
            return (<span>{data}</span>)
        }
    }

    render() {
        let {showTable} = this.state

        const searchOptions = [
            {
              label: 'หมายเลขใบซ่อมยาง',
              value: 'tyre_repair_no'
            },
            {
              label: 'ทะเบียนรถ',
              value: 'vehicle_registration_no'
            },
            {
              label: 'หมายเลขใบแจ้งหนี้',
              value: 'invoice_no'
            }
        ]
        return(
            <div>
                <div style={{display:showTable?'':'none'}}>
                    <ReportGeneralTable 
                        ref='trTable' 
                        title='ใบงานซ่อมยางภายนอก' 
                        newTitle='เพิ่มรายการ'
                        show={this.state.showClose}
                        loadOnShow={this.state.loadClose}
                        showNewButton={true}
                        headerTitles={cHeaderTitles}
                        bodyColumn={['added_date','tyre_repair_no','vehicle_registration_no','vehicle_type','wheel_list','invoice_list','amount']}                        
                        excludeClickColumn={[]}
                        searchOptions={searchOptions}          
                        searchBy={'tyre_repair_no'}
                        loadData={this.loadData.bind(this)}
                        loadDataRange={this.loadDataRange.bind(this)}
                        onRenderColumn={this.onRenderColumn.bind(this)}
                        onRowSelect={this.onRowSelect.bind(this)} 
                        onDocNew={this.onDocNew.bind(this)}
                        showPrintButton={false}
                        isMobile={this.props.isMobile}
                        mobileFieldMap={{title:'request_by',amount:'amount',sub_title:'tyre_repair_no',date:'added_date',status:'',sub_status:''}}
                    />
                </div>
                <div style={{display:!showTable?'':'none'}}>
                    <TyreRepairDoc
                        ref='trDoc'
                        onShow={!showTable?true:false}
                        onCloseClick={this.onDocClose.bind(this)}
                    />
                </div>    
            </div>           
        )
    }
}

ReportTyreRepairPage.defaultProps = {
        
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 480,
  })
  
  export default ReportTyreRepairPage = withSizes(mapSizesToProps)(ReportTyreRepairPage);


// WEBPACK FOOTER //
// ./src/view/tyre/ReportTyreRepairPage.js